import {NavLink} from "react-router-dom";
import {Nav} from "react-bootstrap";

export const SidebarMenuItem = ({menu, basePath}) => {

    const {name, icon, children = [], path, newTab} = menu;

    const hasChildren = children.length > 0 && <ul className="nav nav-treeview">
        {children.sort(x => x.order)
            .map(x => <SidebarMenuItem key={x.path} menu={x} basePath={path}/>)}
    </ul>;

    let correctPath = basePath ? (basePath + '/' + path) : path;
    correctPath = correctPath.split('/').filter(x => x.indexOf(':') === -1).join('/');

    const urlToGo = correctPath;

    const onClick = (e) => {
        if (newTab) {
            window.location = urlToGo;
            e.preventDefault();
            return;
        }
        if (hasChildren) {
            e.preventDefault();
        }
    };

    return (
        <Nav.Item className="nav-item" title={menu.title}>
            <NavLink onClick={onClick} to={urlToGo || ''} className="nav-link">
                <i className={`nav-icon fa ${icon}`}/>
                <p>{name}</p>
                {hasChildren && <i className="fas fa-angle-left right"/>}
            </NavLink>
            {hasChildren}
        </Nav.Item>
    )

}
